export default __webpack_public_path__ + "static/media/033-farmer.4204c47c.svg";